export function timeFix() {
    const time = new Date();
    const hour = time.getHours();
    return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好';
}

export function welcome() {
    const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了'];
    const index = Math.floor(Math.random() * arr.length);
    return arr[index];
}

export function downloadFile(file) {
    getFileBlob(file.url).then(blob => {
        let elink = document.createElement('a');
        elink.href = window.URL.createObjectURL(blob);
        elink.download = file.name;
        document.body.appendChild(elink);
        elink.click();
        window.URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
    });
}

export function getFileBlob(url) {
    return new Promise(resolve => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = () => {
            if (xhr.status === 200) {
                resolve(xhr.response);
            }
        };
        xhr.send();
    });
}

export const scrollPage = vm => {
    const scrollTop = vm.$route.meta.scrollTop;
    if (scrollTop) {
        setTimeout(function () {
            window.scrollTo({top: scrollTop, behavior: 'instant'});
        }, 100)
    }
}

export const timeFormatter = str => {
    if (str) {
        return str.split(" ")[0].split("-").map((item, index) => {
            if (index === 1 && item.startsWith("0") && item.length > 1) {
                return item.substring(1);
            }
            return item
        }).join("/")
    }
}

export function getCookie(cname = 'TOKEN') {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        const c = ca[i].trim();
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}

export function deleteCookie(cname = 'TOKEN') {
    document.cookie = `${cname}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;Max-Age=0;domain=.zngyy.com`;
}

//锚点跳转
export function goAnchor() {
    if (window.location.hash) {
        const anchor = document.querySelector(window.location.hash);//获取元素
        if (anchor) {
            setTimeout(() => {//页面没有渲染完成时是无法滚动的，因此设置延迟
                anchor.scrollIntoView(); //js的内置方法，可滚动视图位置至元素位置
            }, 500);
        }
    }
}


export function getSimpleText(html) {
    //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
    const re1 = new RegExp("<.+?>", "g")
    const msg = html.replace(re1, '')
    return msg;
}
